import * as auditService from '../services/audit';
import { Modal } from 'antd';
import { PATHS, REQUEST_STATUS } from '../utils/constants';

export default {
  namespace: 'svcAudit',
  state: {
    list: [],
    total: 0,
    current: 1,
    pageSize: 10
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *getSvcMeetings(_, { call, put, select }) {
      const { pageSize, current } = yield select(state => state.svcAudit);
      const { data, status, msg } = yield call(auditService.getSvcMeetings, {
        pageNo: current,
        pageSize: pageSize
      });
      if (status === 0) {
        yield put({
          type: 'update',
          payload: { ...data, current: data.pageNo }
        });
      } else {
        Modal.error({ content: msg });
      }
    },
    *auditSvc(
      { meetingId, auditState, remark = '', resolve, reject },
      { select, put, call }
    ) {
      const { status, msg } = yield call(auditService.auditSvc, {
        meetingId,
        auditState,
        remark
      });
      if (status === REQUEST_STATUS.success) {
        yield put({ type: 'getSvcMeetings' });
        resolve && resolve();
      } else {
        reject && reject(msg);
      }
    }
  },
  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === PATHS.svcAudit) {
          dispatch({ type: 'getSvcMeetings' });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/svcAudit.js